<template>
  <div>
    <a-form ref="formRef" class="form" :model="formState" :rules="rules" layout="vertical">
      <a-row :gutter="36">
        <a-col span="8">
          <div class="leftContainer">
            <a-form-item name="name" class="form__item form__item--large" label="Nombre del perfil">
              <a-input v-model:value="formState.name" placeholder="Escribir nombre"></a-input>
            </a-form-item>
            <a-form-item label="Rol asignado" name="roleId">
              <a-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                v-model:value="formState.roleId"
                placeholder="Seleccionar rol asignado"
                @change="handleRole"
              >
                <a-select-option :key="profilesTypes.administrator">
                  Administrador
                </a-select-option>
                <a-select-option :key="profilesTypes.agent"> Agente </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Descripción del perfil" name="observations">
              <a-textarea
                v-model:value="formState.observations"
                class="textarea"
                rows="5"
                placeholder="Escribir descripción del perfil"
                :maxlength="maxObservation"
                @input="handleChangeDescription"
              />
              <span class="char-counter">{{ charCounter }}</span>
            </a-form-item>

            <a-row :gutter="0">
              <a-col span="5">
                <a-form-item class="form-item-icon" label="Ícono" name="icon">
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.icon"
                    class="form__item"
                    placeholder="Elija ícono"
                    @change="showConfirmModal = true"
                  >
                    <a-select-option :key="smile">
                      <img alt="profile icon" class="flag" :src="getProfileImage(smile)" />
                    </a-select-option>
                    <a-select-option :key="lightning">
                      <img alt="profile icon" class="flag" :src="getProfileImage(lightning)" />
                    </a-select-option>
                    <a-select-option :key="userIcon">
                      <img alt="profile icon" class="flag" :src="getProfileImage(userIcon)" />
                    </a-select-option>
                    <a-select-option :key="nut">
                      <img alt="profile icon" class="flag" :src="getProfileImage(nut)" />
                    </a-select-option>
                    <a-select-option :key="activity">
                      <img alt="profile icon" class="flag" :src="getProfileImage(activity)" />
                    </a-select-option>
                    <a-select-option :key="trophy">
                      <img alt="profile icon" class="flag" :src="getProfileImage(trophy)" />
                    </a-select-option>
                    <a-select-option :key="glass">
                      <img alt="profile icon" class="flag" :src="getProfileImage(glass)" />
                    </a-select-option>
                    <a-select-option :key="message">
                      <img alt="profile icon" class="flag" :src="getProfileImage(message)" />
                    </a-select-option>
                    <a-select-option :key="idcard">
                      <img alt="profile icon" class="flag" :src="getProfileImage(idcard)" />
                    </a-select-option>
                    <a-select-option :key="phone">
                      <img alt="profile icon" class="flag" :src="getProfileImage(phone)" />
                    </a-select-option>
                    <a-select-option :key="home">
                      <img alt="profile icon" class="flag" :src="getProfileImage(home)" />
                    </a-select-option>
                    <a-select-option :key="bulb">
                      <img alt="profile icon" class="flag" :src="getProfileImage(bulb)" />
                    </a-select-option>
                    <a-select-option :key="audio">
                      <img alt="profile icon" class="flag" :src="getProfileImage(audio)" />
                    </a-select-option>
                    <a-select-option :key="sound">
                      <img alt="profile icon" class="flag" :src="getProfileImage(sound)" />
                    </a-select-option>
                    <a-select-option :key="customerService">
                      <img
                        alt="profile icon"
                        class="flag"
                        :src="getProfileImage(customerService)"
                      />
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col span="16">
          <div class="rightContainer">
            <a-row :gutter="24">
              <a-col span="12">
                <div class="opciones">
                  <span class="label">Módulos</span>
                  <div class="option">
                    <a-checkbox class="entity" :checked="allCheck" @change="handleCheckAll">
                      Seleccionar todo
                    </a-checkbox>
                    <div class="line-gray" style="margin-bottom: 8px" />
                    <CustomScrollbar height="calc(100% - 24px)" ref="customScrollbar">
                      <a-form-item class="form__item">
                        <div v-for="menu in menusOrganized" :key="menu.id" class="contentEntity">
                          <a-checkbox
                            class="entity"
                            :disabled="
                              menu.name == 'Workspace' && formState.roleId == profilesTypes.agent
                            "
                            :checked="isMenu(menu)"
                            @change="handleMenu($event, menu)"
                          >
                            <strong>{{ menu.name == "Entidades" ? "Empresas" : menu.name }}</strong>
                          </a-checkbox>
                          <div class="line-gray" />
                          <div v-if="menu.name == 'Workspace'" class="menu-flex">
                            <InfoCircleOutlined class="style-icon" />
                            <span class="style-text">
                              {{ textWorkspace }}
                              <router-link to="/account/security" v-if="textWorkspaceLink">
                                {{ textWorkspaceLink }}
                              </router-link>
                            </span>
                          </div>
                          <span v-for="subMenu in menu.items" :key="subMenu.id" class="portfolio">
                            <a-checkbox
                              :checked="issubMenu(subMenu)"
                              @change="handleSubMenu($event, subMenu, menu)"
                            >
                              {{ subMenu.name == "Entidades" ? "Empresas" : subMenu.name }}
                            </a-checkbox>
                          </span>
                        </div>
                      </a-form-item>
                    </CustomScrollbar>
                  </div>
                </div>
              </a-col>
              <a-col span="12">
                <div>
                  <div class="selection">
                    <span class="label">Módulos permitidos</span>
                    <div class="option">
                      <CustomScrollbar height="100%">
                        <div v-for="menu in menusOrganized" :key="menu.id">
                          <div v-if="isMenu(menu)" class="contentEntity">
                            <div class="menu-flex">
                              <span class="label">
                                {{ menu.name == "Entidades" ? "Empresas" : menu.name }}
                              </span>
                              <CloseOutlined
                                v-if="
                                  menu.name != 'Workspace' ||
                                  formState.roleId != profilesTypes.agent
                                "
                                class="close-menu"
                                @click="handleCloseMenu(menu)"
                              />
                            </div>
                            <div v-if="isMenu(menu)" class="line-gray" />
                            <div
                              v-for="subMenu in menu.items"
                              :key="subMenu.name"
                              class="portfolio"
                            >
                              <div v-if="issubMenu(subMenu)" class="seleccion">
                                <span>{{
                                  subMenu.name == "Entidades" ? "Empresas" : subMenu.name
                                }}</span>
                                <CloseOutlined @click="handleCloseSubMenu(subMenu, menu)" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="empty" v-if="menu_id.length == 0">
                          <img
                            alt="profile icon"
                            width="100"
                            class="image-without-modules"
                            :src="modulesImage"
                          />
                        </div>
                      </CustomScrollbar>
                    </div>
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-col>
      </a-row>
    </a-form>
    <div class="footer">
      <a-button
        class="footer__back"
        @click="confirmationModal ? handleConfirmationClose() : handleCancel()"
      >
        Cancelar
      </a-button>
      <a-button
        class="footer__next"
        type="primary"
        :disabled="!menu_id.length"
        :loading="loading"
        @click="
          formState.roleId == profilesTypes.agent && profile.role == profilesTypes.administrator
            ? showModalConfirmation()
            : handleOk()
        "
      >
        Guardar cambios
      </a-button>
    </div>
  </div>
</template>

<script>
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { InfoCircleOutlined, CloseOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import {
  defineComponent,
  reactive,
  ref,
  toRaw,
  computed,
  createVNode,
  h,
  watch,
  watchEffect,
} from "vue";
import { useStore } from "vuex";
import { RolTypes } from "@/app/shared/utils/enums";
import { Modal } from "ant-design-vue";
import { menusIndex } from "@/app/users/utils/constants";
import { fetchActiveUsers } from "@/app/settings/services";
import { updateProfileSocket } from "@/app/shared/services";

import modulesImage from "@/app/users/assets/profiles/modules.png?url";

export default defineComponent({
  components: {
    CustomScrollbar,
    CloseOutlined,
    InfoCircleOutlined,
  },
  setup(_, { emit }) {
    const formRef = ref();
    const store = useStore();
    const profiles = computed(() => store.getters["getProfileList"]);
    const profilesTypes = RolTypes;
    const profile = computed(() => store.getters["getProfile"]);
    const allCheck = ref(false);
    const textWorkspace = ref("");
    const textWorkspaceLink = ref("");
    const menu_id = ref([]);
    const description = ref(profile.value.observations);
    const confirmationModal = ref(false);
    const formState = reactive({
      name: profile.value.name,
      observations: profile.value.observations,
      icon: profile.value.icon !== "" ? profile.value.icon : "smile.svg",
      roleId: profile.value.role,
    });
    textWorkspace.value =
      profile.value.role == profilesTypes.administrator
        ? "Al activar el módulo de Workspace en un perfil con rol administrador, los usuarios de este perfil podrán elegir el ser listados o no en estrategias masivas para gestionar. Esto se activa en "
        : "Los usuarios que pertenezcan a un perfil de rol agente, siempre tendrán activo el módulo de Workspace.";

    textWorkspaceLink.value =
      profile.value.role == profilesTypes.administrator ? "Seguridad y Permisos." : "";

    const checkProfiles = async (rule, value) => {
      if (value == "") {
        return Promise.reject("Campo nombre es requerido");
      } else if (value === profile.value.name) {
        return Promise.resolve();
      } else if (profiles.value.some((item) => item.name === value)) {
        return Promise.reject("Este nombre ya esta en uso");
      } else {
        return Promise.resolve();
      }
    };
    const rules = {
      name: [
        {
          required: true,
          validator: checkProfiles,
          trigger: "change",
        },
      ],
      icon: [
        {
          required: true,
          message: "Campo requerido",
        },
      ],
      observations: [],
      roleId: [
        {
          required: true,
          message: "Campo requerido",
        },
      ],
    };
    // onMounted(() => {
    // });
    menu_id.value = profile.value.options_menu.map((menu) => {
      return menu.id;
    });

    const roleAvailableMenus = computed(() => {
      const menus = store.getters["getMenuList"];

      return menus.flatMap((menu) => [menu.id, ...menu.items.map((item) => item.id)]);
    });

    const menusOrganized = computed(() => {
      const menus = store.getters["getMenuList"];
      const menusOrganized = [];
      for (let i = 0; i < menusIndex.length; i++) {
        const index = menus.findIndex((menu) => menu.name == menusIndex[i]);
        if (index >= 0) menusOrganized.push(menus[index]);
      }
      return menusOrganized;
    });

    watchEffect(() => {
      const menusAll = [];
      menusOrganized.value.forEach((menu) => {
        const subMenus = menu.items;
        menusAll.push(menu.id);
        subMenus.forEach((subMenu) => {
          const someone = menusAll.some((item) => item == subMenu.id);
          if (!someone) menusAll.push(subMenu.id);
        });
      });
      allCheck.value = menusAll.every(id => menu_id.value.includes(id));
      console.log({ menus: menu_id.value });
    });

    watch(formState, () => {
      confirmationModal.value = true;
      emit("onConfirmationModal");
    });

    return {
      formRef,
      formState,
      rules,
      store,
      description,
      profile,
      menu_id,
      allCheck,
      textWorkspace,
      textWorkspaceLink,
      profilesTypes,
      confirmationModal,
      roleAvailableMenus,
      modulesImage,
      menusOrganized,
    };
  },
  data() {
    return {
      search: "",
      lightning: "lightning.svg",
      atom: "atom.svg",
      userIcon: "userIcon.svg",
      nut: "nut.svg",
      activity: "activity.svg",
      trophy: "trophy.svg",
      glass: "glass.svg",
      message: "message.svg",
      idcard: "idcard.svg",
      phone: "phone.svg",
      home: "home.svg",
      bulb: "bulb.svg",
      star: "star.svg",
      customerService: "customerService.svg",
      audio: "audio.svg",
      sound: "sound.svg",
      smile: "smile.svg",
      maxObservation: 75, // Máxima cantidad de caracteres en el campo de "Descripcion del perfil"
      loading: false,
    };
  },
  // watch: {
  //   menu_id(selectedMenus) {
  //     this.allCheck = selectedMenus.length === this.profile?.options_menu?.length;
  //   },
  // },
  computed: {
    // menusOrganized() {
    //   const menus = this.$store.getters["getMenuList"];
    //   const menusOrganized = [];
    //   for (let i = 0; i < menusIndex.length; i++) {
    //     const index = menus.findIndex((menu) => menu.name == menusIndex[i]);
    //     if (index >= 0) menusOrganized.push(menus[index]);
    //   }
    //   return menusOrganized;
    // },
    user() {
      return this.$store.getters["getDataUser"];
    },
    charCounter() {
      return `${this.formState.observations.length}/${this.maxObservation}`;
    },
  },
  mounted() {
    this.store.dispatch("fetchAllMenus", this.profile?.role);
  },
  methods: {
    getProfileImage(profile) {
      return new URL(`../../assets/profiles/${profile}`, import.meta.url).href;
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Deseas descartar los cambios realizados?",
        content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
        width: 450,
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Sí, descartar cambios",
        cancelText: "No, seguir editando",
      });
    },
    onSearch(query) {
      if (this.menusOrganized) {
        if (this.menusOrganized[2].items[0].id == 9 && this.user?.customer?.type_business == 2) {
          this.menusOrganized[2].items.shift();
        }
      }
      const menus = this.menusOrganized;
      let menufiltrados = menus;
      let subfiltrados = [];
      if (query) {
        menufiltrados = menus.filter((menu) => {
          return menu.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
        menus.forEach((menu) => {
          const auxArray = menu.items.map((item) => {
            return item;
          });
          subfiltrados = [...subfiltrados, ...auxArray];
        });
        subfiltrados = subfiltrados.filter(
          (subMenu) => subMenu.name.toLowerCase().indexOf(query.toLowerCase()) > -1
        );
        subfiltrados.forEach((subfiltrado) => {
          const elemt = menus.find((menu) => {
            return menu.id == subfiltrado.parent;
          });
          menufiltrados.push(elemt);
        });
        menufiltrados = menufiltrados.filter((v, i) => menufiltrados.indexOf(v) === i);
      }
      return menufiltrados;
    },
    handleCloseSubMenu(subMenu, menu) {
      const subMenus = menu.items;
      const index = this.menu_id.findIndex((item) => {
        return item == subMenu.id;
      });
      this.menu_id.splice(index, 1);
      const checkMenu = subMenus.some((item) => this.issubMenu(item));
      if (!checkMenu) {
        const index = this.menu_id.findIndex((item) => {
          return item == menu.id;
        });
        this.menu_id.splice(index, 1);
      }
    },
    handleCloseMenu(menu) {
      if (menu.name == "Workspace") {
        Modal.confirm({
          title: "¿Estás seguro de desactivar el módulo de Workspace para este perfil?",
          icon: createVNode(QuestionCircleOutlined),
          content:
            "Recuerda que todos los usuarios asignados a este perfil ya no podrán pertenecer al listado de usuarios disponibles para gestiones masivas (colas y estrategias).",
          onCancel: () => {
            return;
          },
          onOk: () => {
            const index = this.menu_id.findIndex((item) => item == menu.id);
            const subMenus = menu.items;
            this.menu_id.splice(index, 1);
            subMenus.forEach((subMenu) => {
              const index = this.menu_id.findIndex((item) => item == subMenu.id);
              if (index != -1) this.menu_id.splice(index, 1);
            });
          },
          centered: true,
          okText: "Desactivar",
          cancelText: "Cancelar",
        });
      } else {
        const index = this.menu_id.findIndex((item) => item == menu.id);
        const subMenus = menu.items;
        this.menu_id.splice(index, 1);
        subMenus.forEach((subMenu) => {
          const index = this.menu_id.findIndex((item) => item == subMenu.id);
          if (index != -1) this.menu_id.splice(index, 1);
        });
      }
    },
    isMenu(menu) {
      const checked = this.menu_id.includes(menu.id);
      return checked;
    },
    issubMenu(subMenu) {
      const checked = this.menu_id.includes(subMenu.id);
      return checked;
    },
    handleSubMenu(e, subMenu, menu) {
      const checked = e.target.checked;
      const subMenus = menu.items;
      if (checked) {
        //TODO cuando se marque el checkbox+
        const checkeMenu = subMenus.some((item) => this.issubMenu(item));
        if (!checkeMenu && !this.isMenu(menu)) this.menu_id.push(menu.id);
        this.menu_id.push(subMenu.id);
      } else {
        //TODO cuando se desmarque el checkbox
        const index = this.menu_id.findIndex((item) => {
          return item == subMenu.id;
        });
        this.menu_id.splice(index, 1);
        const checkMenu = subMenus.some((item) => this.issubMenu(item));
        if (!checkMenu) {
          const index = this.menu_id.findIndex((item) => {
            return item == menu.id;
          });
          this.menu_id.splice(index, 1);
        }
      }
    },
    handleMenu(e, menu) {
      if (menu.name == "Workspace" && !e.target.checked) {
        Modal.confirm({
          title: "¿Estás seguro de desactivar el módulo de Workspace para este perfil?",
          icon: createVNode(QuestionCircleOutlined),
          content:
            "Recuerda que todos los usuarios asignados a este perfil ya no podrán pertenecer al listado de usuarios disponibles para gestiones masivas (colas y estrategias).",
          onCancel: () => {
            console.log("CANCEL");
            return;
          },
          onOk: () => this.toggleCheckBoxMenu(menu, e.target.checked),
          centered: true,
          okText: "Desactivar",
          cancelText: "Cancelar",
        });
      } else {
        this.toggleCheckBoxMenu(menu, e.target.checked);
      }
    },
    toggleCheckBoxMenu(menu, checked) {
      // let checked = e.target.checked;
      const subMenus = menu.items;

      if (checked) {
        this.menu_id.push(menu.id);
        subMenus.forEach((subMenu) => {
          const someone = this.menu_id.some((item) => item == subMenu.id);
          if (!someone) this.menu_id.push(subMenu.id);
        });
      } else {
        const index = this.menu_id.findIndex((item) => item == menu.id);
        this.menu_id.splice(index, 1);
        subMenus.forEach((subMenu) => {
          const index = this.menu_id.findIndex((item) => item == subMenu.id);
          if (index != -1) this.menu_id.splice(index, 1);
        });
      }
    },
    async showModalConfirmation() {
      Modal.confirm({
        title: "¿Estás seguro de cambiar este perfil de rol Administrador a rol Agente?",
        content: h('span', [
          'Recuerda que todos los usuarios asignados a este perfil perderán los privilegios del rol administrador. Para más detalles ',
          h('a', { 
            href: 'https://beexcc.com/docs/contact-center/mini-menu/equipo-de-trabajo/', 
            target: '_blank', 
            rel: 'noopener noreferrer' 
          }, 'haz click aquí')
        ]),
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleOk(),
        centered: true,
        okText: "Cambiar",
        cancelText: "Cancelar",
      });
    },
    async handleOk() {
      try {
        let obj = {};
        this.formRef.validateFields().then(async () => {
          const data = toRaw(this.formState);
          obj = {
            name: data.name,
            observations: data.observations,
            icon: data.icon,
            role: data.roleId,
            menu_id: this.menu_id,
          };
          this.loading = true;
          await this.store.dispatch("updateProfile", {
            id: this.profile.id,
            params: obj,
          });
          await this.updateUsers();
          this.loading = false;
          this.$emit("emitEdit");
          this.$message.success("La edición del perfil se ha realizado correctamente");
        });
      } catch (error) {
        this.$message.error("Error al editar el perfil");
      }
    },
    async updateUsers() {
      const users = await fetchActiveUsers();
      const usersProfile = users.results.filter(
        (user) => user.profile == this.profile.id && user.status == 1
      );
      usersProfile.forEach((user) => {
        updateProfileSocket({
          customer_id: this.user.customer.id,
          user_id: user.id,
          title: "Un administrador a realizado cambios en tu perfil",
          description: "Se han editado los datos o permisos de tu perfil",
        });
      });
    },
    handleCancel() {
      this.confirmationModal = false;
      this.$emit("emitEdit");
    },
    handleChangeDescription(event) {
      this.description = event.target.value;
    },
    handleDeselectAll() {
      this.menu_id = [];
      if (this.formState.roleId == this.profilesTypes.agent) {
        const workspace = this.menusOrganized.find((item) => item.name == "Workspace");
        this.menu_id.push(workspace.id);
      }
    },
    handleCheckAll(event) {
      this.allCheck = event.target.checked;
      if (this.allCheck) {
        // this.menu_id = this.profile.options_menu.map((menu) => menu.id);

        this.menusOrganized.forEach((menu) => {
          const subMenus = menu.items;
          this.menu_id.push(menu.id);
          subMenus.forEach((subMenu) => {
            const someone = this.menu_id.some((item) => item == subMenu.id);
            if (!someone) this.menu_id.push(subMenu.id);
          });
        });
      } else {
        // this.menusOrganized.forEach((menu) => {
        //   const subMenus = menu.items;
        //   subMenus.forEach((subMenu) => {
        //     const index = this.menu_id.findIndex((item) => item == subMenu.id);
        //     if (index != -1) this.menu_id.splice(index, 1);
        //   });
        // });
        this.handleDeselectAll();
      }
    },
    handleRole(role) {
      this.store.dispatch("fetchAllMenus", role);
      this.$refs.customScrollbar?.scrollToTop();
      this.handleDeselectAll();
      if (role == this.profilesTypes.administrator) {
        this.textWorkspace =
          "Al activar el módulo de Workspace en un perfil con rol administrador, los usuarios de este perfil podrán elegir el ser listados o no en estrategias masivas para gestionar. Esto se activa en ";
        this.textWorkspaceLink = "Seguridad y Permisos";
      } else {
        this.textWorkspace =
          "Los usuarios que pertenezcan a un perfil de rol agente, siempre tendrán activo el módulo de Workspace.";
        this.textWorkspaceLink = "";
        const workspace = this.menusOrganized.find((item) => item.name == "Workspace");
        if (!this.menu_id.some((item) => item === workspace.id)) this.menu_id.push(workspace.id);
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.container
  padding: 30px 60px 0px
.label
  font-weight: 600
  font-size: $font-normal
  line-height: 22px
  color: $gray-9
.btn-search
  margin-bottom: 12px
.option
  background: $white
  border: 1px solid $gray-6
  height: 60vh
  margin-bottom: 20px
  padding: 8px 12px
.flag
  width: 20px
  filter: invert(34%) sepia(15%) saturate(0%) hue-rotate(197deg) brightness(98%) contrast(94%)
.form
  overflow: hidden
  margin-bottom: 10px
.containerRight
  background: $white
  border: 1px solid $gray-6
  height: 373px
  border-radius: 3px
  padding: 10px 25px
.entity
  width: 100%
  text-align: left
.portfolio
  margin-left: 28px
  margin-top: 9px
  display: flex
.contentEntity
  margin-bottom: 10px
.seleccion
  background: $blue-1
  border: 1px solid $blue-3
  box-sizing: border-box
  border-radius: 2px
  font-size: $font-small
  line-height: 20px
  color: $gray-8
  width: 100%
  height: 30px
  display: flex
  align-items: center
  margin: 0 auto
  justify-content: space-between
  padding: 0 8px
.textarea
  position: relative
  border: 1px solid $gray-5
  border-radius: 4px
  &::placeholder
    color: $gray-6
  &:hover
    border: 1px solid $blue-5
  &:focus
    border: 1px solid $blue-5
.counter
  position: absolute
  right: 12px
  bottom: 12px
  font-size: $font-small
  color: $gray-6
.footer
  position: absolute
  left: 0
  width: 100%
  height: 56px
  display: flex
  bottom: 0
  background: $white
  align-items: center
  justify-content: flex-end
  border-radius: 0px 0px 8px 8px
  &__next
    margin-right: 1rem
  &__back
    margin-right: 1rem

.line-gray
  border: 1px solid #E8E8E8
.close-menu
  padding-right: 10px
  padding-top: 5px
  color: $gray-8
.menu-flex
  display: flex
  justify-content: space-between
  margin-top: 8px

.empty
  display: grid
  place-content: center
  place-items: center
  height: 100%

.style-icon
  font-size: 12px
  margin-top: 3px

.style-text
  padding: 0 5px
  font-style: italic
  font-size: 12px
  color: $gray-8

.style-italic
  font-style: italic
  display: flex
.section-modules
  height: calc(100% - 30px)
  margin-top: 10px
  padding-left: 8px
.char-counter
  position: absolute
  left: 87%
  top: 77%
  color: $gray-6
textarea
  resize: none
</style>
